// Which league the URL is about.
//
// One line, and it lives on its own because three unrelated modules need it —
// the router's shell, the app shell's chrome, and the simulator — and the
// first two should not have to import the simulator to ask a question about a
// path. It was exported from `SimProvider` until 2026-09-17, which made
// "which league am I looking at" a question only the simulated world could
// answer.

import { matchPath } from 'react-router-dom';

/** `/l/<id>/…` → the id; anything else → null. */
export function leagueIdFromPath(pathname: string): string | null {
  return matchPath('/l/:leagueId/*', pathname)?.params.leagueId ?? null;
}
